"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterHeaderFooterData = exports.encodeSearchQueryParams = exports.Locales = exports.Companies = void 0;
var Companies;

(function (Companies) {
  Companies["ryerson"] = "Ryerson";
  Companies["southernToolSteel"] = "Southern Tool Steel";
})(Companies || (exports.Companies = Companies = {}));

var Locales;

(function (Locales) {
  Locales["en"] = "en-US";
  Locales["es"] = "es-MX";
  Locales["fr"] = "fr-CA";
})(Locales || (exports.Locales = Locales = {}));

var encodeSearchQueryParams = function encodeSearchQueryParams(params) {
  var encodedParams = "";
  Object.keys(params).forEach(function (key) {
    encodedParams += "".concat(key, "=").concat(encodeURIComponent(params[key]), "&");
  });
  return encodedParams.substring(0, encodedParams.length - 1);
};

exports.encodeSearchQueryParams = encodeSearchQueryParams;

var filterHeaderFooterData = function filterHeaderFooterData(headerFooterData, locale, companyName, country) {
  var _a, _b, _c;

  var companyQueryField = Companies[companyName];
  var productMenusOriginal = (_a = headerFooterData.allContentfulHeaderFooterData.nodes.filter(function (node) {
    return node.node_locale === locale && node.company.includes(companyQueryField);
  })[0]) === null || _a === void 0 ? void 0 : _a.data.productMenus.sort(function (menuA, menuB) {
    var retVal = 0;
    menuA.order < menuB.order && (retVal = -1);
    menuA.order < menuB.order && (retVal = 1);
    return retVal;
  });
  var productMenus = JSON.parse(JSON.stringify(productMenusOriginal));
  var productCategories = headerFooterData.contentfulProductCategories.productCategories.productCategories;
  productMenus[0].items = productMenus[0].items.map(function (product) {
    var productCategory = productCategories.find(function (category) {
      return category.id.substring(0, 3) === product.id;
    });
    product.product = productCategory === null || productCategory === void 0 ? void 0 : productCategory.product;
    product.items = product.items.map(function (productForm) {
      productForm.items = productForm.items.map(function (productFormShape) {
        var productCategory = productCategories.find(function (category) {
          return category.id === productFormShape.id;
        });
        return Object.assign(Object.assign({}, productFormShape), productCategory);
      });
      return productForm;
    });
    return product;
  });
  var globalMenus = (_b = headerFooterData.allContentfulHeaderFooterData.nodes.filter(function (node) {
    return node.node_locale === locale && node.company.includes(companyQueryField);
  })[0]) === null || _b === void 0 ? void 0 : _b.data.globalMenus;
  var links = (_c = headerFooterData.allContentfulHeaderFooterData.nodes.filter(function (node) {
    return node.node_locale === locale && node.company.includes(companyQueryField);
  })[0]) === null || _c === void 0 ? void 0 : _c.data.links;
  var countries = JSON.parse(headerFooterData.allContentfulCountryStatesProvinces.edges[0].node.countries.internal.content);
  var locations = countries[country];
  var headerData = {
    globalMenus: globalMenus,
    productMenus: productMenus,
    productCategories: productCategories,
    locations: locations
  };
  var footerData = {
    productMenus: productMenus,
    links: links
  };
  return {
    headerData: headerData,
    footerData: footerData
  };
};

exports.filterHeaderFooterData = filterHeaderFooterData;